import useVideoContext from '../useVideoContext/useVideoContext';
import useDominantSpeaker from '../useDominantSpeaker/useDominantSpeaker';
import useParticipants from '../useParticipants/useParticipants';
import useScreenShareParticipant from '../useScreenShareParticipant/useScreenShareParticipant';
import useSelectedParticipant from '../../components/VideoProvider/useSelectedParticipant/useSelectedParticipant';

export default function useMainParticipant() {
  const [selectedParticipant] = useSelectedParticipant();
  const screenShareParticipant = useScreenShareParticipant();
  const dominantSpeaker = useDominantSpeaker();
  const participants = useParticipants();
  const filteredParticipants = participants.filter(p => !p.identity.split('###')[1].startsWith('CP##'))
  const { room } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const localScreenShareParticipant = screenShareParticipant === localParticipant ? screenShareParticipant : null;
  const remoteScreenShareParticipant = screenShareParticipant !== localParticipant ? screenShareParticipant : null;

  // The participant that is returned is displayed in the main video area. Changing the order of the following
  // variables will change the how the main speaker is determined.
  return (
    selectedParticipant ||
    localScreenShareParticipant ||
    remoteScreenShareParticipant ||
    dominantSpeaker ||
    filteredParticipants[0] ||
    localParticipant
  );
}
